export default "__VITE_ASSET__C$M33JTY__"